(() => {
  'use strict';
  // The cart form is the owner of the copy payload. On the cart page the page
  // form wins even though the header drawer renders its own copy payload.
  const copyNode = document.querySelector('#CartPageForm [data-fs-cart-copy]') || document.querySelector('[data-fs-cart-copy]');
  const form = copyNode ? copyNode.closest('form') : document.getElementById('CartPageForm');
  if (!form || !copyNode) return;
  const drawer = form.classList.contains('cart__drawer-form');
  const page = form.closest('.fs-cart-page') || form.closest('.site-header__cart') || form;
  const copy = JSON.parse(copyNode.textContent);
  const choice = form.querySelector('[data-fs-protection] input[type="checkbox"]');
  const protection = form.querySelector('[data-fs-protection]');
  const protectionNote = form.querySelector('[data-fs-protection-note]');
  const skipLink = form.querySelector('[data-fs-checkout-skip]');
  const bar = form.querySelector('[data-fs-mobile-bar]');
  const error = form.querySelector('[data-fs-cart-error]');
  const buttons = [...form.querySelectorAll('[data-fs-checkout]')];
  const chatLink = form.querySelector('[data-fs-cart-chat]');
  const optOutKey = 'fsProtectionOptOut:v2';
  const maxAutoTries = 6;
  // Navidium can publish its protection price before its variant id, so the
  // variant gets a bounded product lookup instead of an immediate give-up.
  const maxVariantFetches = 2;
  const variantRetryDelay = 300;
  // Navidium republishes its quote just after the first cart render. The first
  // automatic inclusion waits this bounded window, and an add is held back while a
  // republished quote is still settling, so a previous tier is never pinned.
  const initialQuoteDelay = 150;
  const quoteSettleDelay = 150;
  // A cart add can land on a stored quote that still belongs to the previous cart
  // and agrees with itself, so the add waits for Navidium to republish either key.
  // A later add in the same price tier republishes nothing, hence the short bounded
  // fallback that then uses the stored quote. Navidium's own running flag shortens
  // the wait further: while it recalcs the gate retries instead of waiting blind.
  const quoteGateLimit = 250;
  const quoteGateRetry = 100;
  const maxSettleWaits = 4;
  const quoteWatchInterval = 400;
  const quoteWatchLimit = 10000;
  // A reconcile cycle is bounded. The panel opens on the add itself, so the cycle
  // only has to end even when Navidium never republishes the quote or the rebuild
  // it asked for never announces a render.
  const cycleLimit = 7500;
  const maxQuoteFollowUps = 2;
  // Navidium rewrites its stored variant and its stored price in separate passes, so
  // a pair that disagrees with its own price is a quote still being written. It gets
  // a short grace period before the exact-price fallback may decide anything.
  const quoteConsistencyWait = 1500;
  // The fuel function reprices its own variant, so the cart only has to hold that one
  // line. The attempt count is bounded so a refused add cannot loop.
  const fuelVariantId = 67755231313965;
  const fuelHandle = 'fuel-surcharge';
  const maxFuelTries = 2;
  if (chatLink) chatLink.addEventListener('click', event => {
    event.preventDefault();
    const status = form.querySelector('[data-fs-cart-chat-error]');
    try {
      if (!window.$crisp || typeof window.$crisp.push !== 'function') throw new Error('Chat unavailable');
      window.$crisp.push(['do', 'chat:show']);
      window.$crisp.push(['do', 'chat:open']);
      status.hidden = true;
    } catch (_) {
      status.textContent = copy.chatUnavailable;
      status.hidden = false;
    }
  });
  let choiceTouched = false;
  let proceeding = false;
  let mutating = false;
  let scheduled = false;
  let synced = false;
  let enhanced = false;
  let inCart = false;
  let protectionDom = null;
  let protectionProduct = null;
  let protectionVariantId = null;
  let variantLoading = false;
  let variantFetches = 0;
  let quoteVariant = null;
  let quotePrice = null;
  let quoteChangedAt = 0;
  let quoteGateOpen = false;
  let quoteGateVariant = null;
  let quoteGatePrice = null;
  let quoteGateDeadline = 0;
  // Whether Navidium reported itself as actively recalculating during this gate, so
  // the gate can release the moment that work ends instead of waiting out the cap.
  let quoteGateSawRunning = false;
  let quoteInconsistentAt = 0;
  let settleWaits = 0;
  let quoteWatchTimer = 0;
  let price = '';
  let linePrice = '';
  let linePriceLoading = false;
  let autoTries = 0;
  let autoDone = false;
  let autoTimer = 0;
  const autoStartAt = Date.now() + initialQuoteDelay;
  let count = 0;
  let settled = false;
  let renderPending = false;
  let renderTimer = 0;
  let renderEpoch = 0;
  let addedEpoch = -1;
  // One reconcile cycle per add (and one on a page load that already holds
  // protection). Nothing may settle a cycle while it is still deciding the line.
  let cycleId = 0;
  let cycleActive = false;
  let cycleTimer = 0;
  let quoteFollowUps = 0;
  let loadCycleStarted = false;
  let fuelLoading = false;
  let fuelTries = 0;
  function text(el, value) {
    if (el && el.textContent !== value) el.textContent = value;
  }
  function money(el, value) {
    if (el && el.innerHTML !== value) el.innerHTML = value;
  }
  function appButtons() {
    return {
      withProtection: form.querySelector('#nvd-with-checkout-btn'),
      withoutProtection: form.querySelector('#nvd-without-checkout-btn'),
      price: form.querySelector('.nvd-mini .nvd-title span')
    };
  }
  function showError(message) {
    text(error, message);
    error.hidden = false;
  }
  function stored(key) {
    try { return window.localStorage.getItem(key); } catch (_) { return null; }
  }
  function store(key, value) {
    try {
      if (value === null) window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, value);
    } catch (_) { /* Storage can be unavailable; the cart still works. */ }
  }
  function optedOut() {
    return stored(optOutKey) === 'true';
  }
  function setOptedOut(value) {
    store(optOutKey, value ? 'true' : null);
  }
  function currentVariantId() {
    const raw = stored('nvdVariant');
    const id = Number(raw);
    return raw !== null && raw !== '' && Number.isSafeInteger(id) && id > 0 ? id : null;
  }
  function storedProtectionPrice() {
    const raw = stored('nvdProtectionPrice');
    if (raw === null) return null;
    const textValue = String(raw).trim();
    if (!/^\d+$/.test(textValue)) return null;
    const value = Number(textValue);
    return Number.isSafeInteger(value) && value > 0 ? value : null;
  }
  function singleVariantMode() {
    return typeof nvdWidgetConfig !== 'undefined' && String(nvdWidgetConfig.nvd_single_variant) === '1';
  }
  // Navidium rewrites its stored variant and price whenever its quote changes. A
  // resolution made for the previous quote must not survive that change, so both
  // keys are compared on every read and a new tier starts a new bounded lookup.
  function reconcileQuote() {
    const variant = currentVariantId();
    const amount = storedProtectionPrice();
    if (variant === quoteVariant && amount === quotePrice) return false;
    protectionVariantId = null;
    if (amount !== quotePrice) {
      // The displayed prospective price belonged to the previous tier.
      price = '';
      variantFetches = 0;
    }
    quoteVariant = variant;
    quotePrice = amount;
    quoteChangedAt = Date.now();
    return true;
  }
  function quoteSettling() {
    reconcileQuote();
    return quoteChangedAt > 0 && Date.now() - quoteChangedAt < quoteSettleDelay;
  }
  // The quote that was stored when the add happened is the only thing Navidium has
  // published at that moment, and it can be a self-consistent leftover of the
  // previous cart. The automatic inclusion therefore waits until either key is
  // republished, or until the bounded fallback window shows that this add kept the
  // same tier.
  function openQuoteGate() {
    quoteGateVariant = currentVariantId();
    quoteGatePrice = storedProtectionPrice();
    quoteGateDeadline = Date.now() + quoteGateLimit;
    quoteGateSawRunning = false;
    quoteGateOpen = true;
    settleWaits = 0;
  }
  // Navidium publishes its recalculation in progress as this stored flag. It is
  // only ever read, never written: a fake cart-changed event would make Navidium
  // add protection on its own.
  function nvdRunning() {
    return stored('nvd_running') === 'true';
  }
  function quoteGateWait() {
    if (!quoteGateOpen) return 0;
    const variant = currentVariantId();
    const amount = storedProtectionPrice();
    if (variant !== quoteGateVariant || amount !== quoteGatePrice) {
      // The post-add quote arrived; the settle window takes over from here.
      quoteGateSawRunning = false;
      quoteGateOpen = false;
      return 0;
    }
    const remaining = quoteGateDeadline - Date.now();
    if (nvdRunning()) {
      // Navidium is recalculating: keep a short retry inside the same cap, then
      // fall through to the stored quote if it never republishes.
      quoteGateSawRunning = true;
      if (remaining > 0) return Math.min(quoteGateRetry, remaining);
      quoteGateOpen = false;
      return 0;
    }
    if (quoteGateSawRunning) {
      // Navidium finished and left both keys untouched, so the add kept its tier.
      quoteGateSawRunning = false;
      quoteGateOpen = false;
      return 0;
    }
    if (remaining <= 0) {
      quoteGateOpen = false;
      return 0;
    }
    return remaining;
  }
  function settleWait() {
    if (!quoteChangedAt) return 0;
    const remaining = quoteChangedAt + quoteSettleDelay - Date.now();
    return remaining > 0 ? remaining : 0;
  }
  // Navidium writes its stored variant and its price in separate passes, so a pair
  // that moved while the cart was being read cannot decide the protection line yet.
  // Nothing may be concluded from it until the settle window has run out again.
  function quoteReloading() {
    if (!reconcileQuote()) return 0;
    return settleWait() || quoteSettleDelay;
  }
  // A stored variant whose own price disagrees with the stored price is the middle of
  // Navidium's two-step write, not a settled answer. The pair is given the bounded
  // grace to finish; only then may the exact-price fallback decide the line.
  function quoteConsistencyWaitLeft() {
    if (!quoteVariant || quotePrice === null || !Array.isArray(protectionProduct)) {
      quoteInconsistentAt = 0;
      return 0;
    }
    const stored = protectionProduct.find(entry => String(entry.id) === String(quoteVariant));
    if (!stored || Number(stored.price) === quotePrice) {
      quoteInconsistentAt = 0;
      return 0;
    }
    if (!quoteInconsistentAt) quoteInconsistentAt = Date.now();
    const remaining = quoteInconsistentAt + quoteConsistencyWait - Date.now();
    return remaining > 0 ? remaining : 0;
  }
  function requestProtectionProduct() {
    if (variantLoading || !copy.protectionUrl || variantFetches >= maxVariantFetches) return;
    variantFetches++;
    variantLoading = true;
    fetch(copy.protectionUrl + '.js', {
      credentials:'same-origin', headers:{'Accept':'application/json'}, signal:AbortSignal.timeout(10000)
    })
      .then(response => (response.ok ? response.json() : null))
      .then(product => {
        const variants = product && Array.isArray(product.variants) ? product.variants : null;
        if (variants) protectionProduct = variants;
      })
      .catch(() => { /* A later bounded retry or the stored quote stays authoritative. */ })
      .finally(() => {
        variantLoading = false;
        queueSync();
      });
  }
  // Same-price tiers share a price, so the first variant at that price is not
  // necessarily the one Navidium quoted. Its own stored variant wins while it
  // carries the current price; any other variant at that exact price is the
  // fallback, and a stored variant at another price is never used.
  function exactPriceVariant(amount) {
    if (!Array.isArray(protectionProduct)) return null;
    const matching = protectionProduct.filter(entry =>
      Boolean(entry) && Number(entry.price) === amount &&
      Number.isSafeInteger(Number(entry.id)) && Number(entry.id) > 0
    );
    if (!matching.length) return null;
    const quoted = quoteVariant === null
      ? null
      : matching.find(entry => String(entry.id) === String(quoteVariant));
    return Number((quoted || matching[0]).id);
  }
  // The variant that carries the exact current price always wins once Navidium has
  // published a price. A stored variant that disagrees with that price is stale and
  // is never added; the stored variant is only trusted while no price exists to
  // check it against.
  function resolveProtectionVariant() {
    // The stored quote is re-read first so a resolution made for an earlier tier is
    // never returned, even when the caller already has one.
    reconcileQuote();
    if (singleVariantMode()) {
      // Navidium's single-variant dynamic fee keeps one catalog variant and rewrites
      // its price at checkout, so a catalog match would always reject the quote. That
      // variant is the fee, and the displayed amount follows the quote instead.
      const configured = quoteVariant || Number(nvdWidgetConfig.min_variant_id);
      const variant = Number.isSafeInteger(configured) && configured > 0 ? configured : null;
      if (!variant) return null;
      protectionVariantId = variant;
      if (quotePrice !== null) price = formatMoney(quotePrice);
      return variant;
    }
    if (protectionVariantId) return protectionVariantId;
    if (quotePrice === null) {
      if (!quoteVariant) {
        // The top catalog tier is the fee itself and Cart Transform reprices it, so a
        // cart that clearly carries more than $89 of fee uses it while no quote exists.
        const subtotal = Number(form.querySelector('[data-fs-cart-state]')?.dataset.cartSubtotal);
        if (subtotal >= 252000) {
          protectionVariantId = 41259656937517;
          return 41259656937517;
        }
        return null;
      }
      protectionVariantId = quoteVariant;
      return quoteVariant;
    }
    const exact = exactPriceVariant(quotePrice);
    if (exact) {
      protectionVariantId = exact;
      // This quote already prices the line, so no second product request runs.
      if (!price) price = formatMoney(quotePrice);
      return exact;
    }
    // The current tier is missing from the cached product: drop it, refresh within
    // the bound and let the next sync retry instead of adding another tier.
    protectionProduct = null;
    requestProtectionProduct();
    return null;
  }
  function formatMoney(cents) {
    try {
      const currency = copy.currency || 'USD';
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency}).format(cents / 100);
    } catch (_) { return ''; }
  }
  function pause(ms) {
    return new Promise(resolve => window.setTimeout(resolve, ms));
  }
  function cacheBust(url, label) {
    return url + (url.includes('?') ? '&' : '?') + label + '=' + Date.now();
  }
  async function readCart() {
    const response = await fetch(cacheBust(copy.cartUrl, 'fs_protection'), {
      credentials:'same-origin', headers:{'Accept':'application/json'}, signal:AbortSignal.timeout(10000)
    });
    if (!response.ok) throw new Error('Cart could not be read');
    return response.json();
  }
  async function writeCart(url, body) {
    const response = await fetch(url, {
      method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify(body), signal:AbortSignal.timeout(15000)
    });
    if (!response.ok) throw new Error('Cart could not be updated');
    return response.json().catch(() => null);
  }
  function markFeeTestCart() {
    writeCart(copy.updateUrl, {attributes:{_fs_fee_test:'1'}}).catch(() => {});
  }
  function protectionLines(cart) {
    const items = cart && Array.isArray(cart.items) ? cart.items : [];
    return items.filter(item =>
      (protectionVariantId && String(item.variant_id) === String(protectionVariantId)) ||
      /shipping-protection|navidium/i.test(item.handle || '')
    );
  }
  function protectionLine(cart) {
    return protectionLines(cart)[0] || null;
  }
  // A protection line being in the cart says nothing about which tier it belongs
  // to. The line is only current when it is the exact variant the quote resolved,
  // carries a single unit and is the only protection line in the cart.
  function lineIsCurrent(cart) {
    if (!protectionVariantId) return false;
    const lines = protectionLines(cart);
    return lines.length === 1 &&
      String(lines[0].variant_id) === String(protectionVariantId) &&
      Number(lines[0].quantity) === 1;
  }
  function reviewBusy() {
    try {
      return Boolean(window.FsCartReview && typeof window.FsCartReview.isBusy === 'function' && window.FsCartReview.isBusy());
    } catch (_) { return false; }
  }
  async function confirmReview(cart) {
    const review = window.FsCartReview;
    if (!review || typeof review.beforeAdd !== 'function') return cart;
    const confirmed = await review.beforeAdd(cart);
    return confirmed && Array.isArray(confirmed.items) ? confirmed : cart;
  }
  function locked(run) {
    const coordinator = window.FsNativePromotionCoordinator;
    return coordinator && typeof coordinator.withCartLock === 'function' ? coordinator.withCartLock(run) : run();
  }
  function rebuild() {
    // The rebuild replaces the drawer rows and the subtotal; the settled signal
    // must wait for that render instead of firing on the pre-rebuild markup.
    renderPending = true;
    window.clearTimeout(renderTimer);
    renderTimer = window.setTimeout(() => {
      // A failed or superseded build never dispatches cart:rendered; release the
      // gate so a stuck render can only delay the drawer to this bound.
      renderPending = false;
      queueSync();
    }, 3000);
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('nvd_cart_changed'));
  }
  // The fuel line is inserted once the shopper's own merchandise is in the cart. The
  // cart is read here, the write is coordinated through the cart lock, and the result
  // is confirmed before the UI is rebuilt. A cart that held nothing but fees is
  // cleaned up instead, so a fee-only cart never keeps a fuel or protection line. A
  // refusal stays quiet.
  async function ensureFuelLine() {
    if (fuelLoading || fuelTries >= maxFuelTries) return;
    fuelLoading = true;
    try {
      const cart = await readCart();
      const items = cart && Array.isArray(cart.items) ? cart.items : [];
      if (!items.length) return;
      // Protection and fuel lines are not merchandise: a cart that holds only those
      // never gets a fuel line of its own.
      const assurance = protectionLines(cart);
      const feeLines = items.filter(item => {
        if (!item) return false;
        const handle = String(item.handle || '');
        return handle === fuelHandle || assurance.includes(item) || /assure/i.test(handle);
      });
      const merchandise = items.some(item => Boolean(item) && !feeLines.includes(item));
      if (!merchandise) {
        // No merchandise is left, so the fee lines are cleared in one write and no
        // fuel line is added. The opt-out is reset here as well, because an emptied
        // cart must not keep blocking protection for the next shopping session.
        setOptedOut(false);
        const updates = {};
        let changed = false;
        feeLines.forEach(item => {
          if (!item.key) return;
          updates[item.key] = 0;
          changed = true;
        });
        if (!changed) return;
        fuelTries++;
        await locked(() => writeCart(copy.updateUrl, {updates}));
        rebuild();
        return;
      }
      // Cart Transform prices the fee lines only for a cart marked as a fee-test
      // cart, so the marker is written before the drawer is trusted with a price.
      // It is also repaired when the fuel line is already present, so a stale cart
      // never keeps showing the unmarked fee prices.
      const needsFeeTest = cart.attributes?._fs_fee_test !== '1';
      // The fee lines are added once, so a cart that already holds the fuel line is
      // only repaired here. Protection that was blocked before the opt-out reset is
      // still given its own inclusion chance instead of waiting for a rebuild.
      const merchCents = items
        .filter(item => Boolean(item) && !feeLines.includes(item))
        .reduce((sum, item) => sum + Number(item.final_line_price || 0), 0);
      if (items.some(item => item && item.handle === fuelHandle)) {
        if (!assurance.length && !optedOut() && !choiceTouched && merchCents >= 245000) queueAutoInclude(0);
        if (!needsFeeTest) return;
        fuelTries++;
        await locked(async () => {
          await writeCart(copy.updateUrl, {attributes:{_fs_fee_test:'1'}});
          rebuild();
        });
        return;
      }
      // The fuel write is the only write this cart needs, so protection rides along in
      // the same add instead of waiting for a second rebuild to reconcile it. The top
      // catalog tier is used while no quote has resolved, because Cart Transform
      // reprices that line at checkout.
      if (!optedOut() && !choiceTouched && !assurance.length) resolveProtectionVariant();
      const initialAssureId = (!optedOut() && !choiceTouched && !assurance.length)
        ? (protectionVariantId || (merchCents >= 245000 ? 41259656937517 : null))
        : null;
      fuelTries++;
      await locked(async () => {
        if (needsFeeTest) await writeCart(copy.updateUrl, {attributes:{_fs_fee_test:'1'}});
        await writeCart(copy.addUrl, {
          items: initialAssureId
            ? [{id:initialAssureId, quantity:1}, {id:fuelVariantId, quantity:1}]
            : [{id:fuelVariantId, quantity:1}]
        });
        const after = await readCart();
        const confirmed = (after && Array.isArray(after.items) ? after.items : [])
          .some(item => item && item.handle === fuelHandle);
        if (confirmed) rebuild();
      });
    } catch (_) {
      // A refused or unconfirmed fuel line never blocks the rest of the cart.
    } finally {
      fuelLoading = false;
    }
  }
  function loadPrice() {
    if (price || !protectionVariantId) return;
    if (!Array.isArray(protectionProduct)) {
      requestProtectionProduct();
      return;
    }
    const variant = protectionProduct.find(entry => String(entry.id) === String(protectionVariantId));
    const formatted = variant ? formatMoney(Number(variant.price)) : '';
    if (!formatted) return;
    price = formatted;
    queueSync();
  }
  function loadLinePrice() {
    // The line cache stays authoritative while protection is in the cart, so this
    // refresh must run even when the app/product price is already known. Only an
    // overlapping request is skipped.
    if (linePriceLoading) return;
    linePriceLoading = true;
    readCart()
      .then(cart => {
        const line = protectionLine(cart);
        const formatted = line ? formatMoney(Number(line.final_line_price)) : '';
        if (!formatted || formatted === linePrice) return;
        // The loading guard is still set, so this direct render cannot re-request.
        linePrice = formatted;
        sync();
      })
      .catch(() => { /* The app price text or the product price stay authoritative off-cart. */ })
      .finally(() => { linePriceLoading = false; });
  }
  // Shopify applies one updates map in a single write, so the old protection key and
  // the newly quoted variant move together and the cart never holds both lines. The
  // result is verified before it is trusted, and the repair path only ever removes a
  // key it has just read and adds one variant afterwards, so it cannot duplicate the
  // line or send an id the cart does not have.
  async function writeProtectionLine(cart, variantId) {
    const lines = protectionLines(cart);
    const keep = lines.find(entry => String(entry.variant_id) === String(variantId)) || null;
    const updates = {};
    let changed = false;
    lines.forEach(entry => {
      if (entry === keep) {
        if (Number(entry.quantity) !== 1) {
          updates[entry.key] = 1;
          changed = true;
        }
        return;
      }
      // Every older or duplicated protection line goes in the same write.
      updates[entry.key] = 0;
      changed = true;
    });
    if (!keep) {
      updates[String(variantId)] = 1;
      changed = true;
    }
    if (!changed) return cart;
    let applied = null;
    try {
      applied = await writeCart(copy.updateUrl, {updates});
    } catch (_) {
      // An update map the cart cannot honour is verified and repaired below.
      applied = null;
    }
    if (applied && lineIsCurrent(applied)) return applied;
    const after = await readCart().catch(() => null);
    if (after && lineIsCurrent(after)) return after;
    return repairProtectionLine(variantId);
  }
  async function repairProtectionLine(variantId) {
    for (let attempt = 0; attempt < 6; attempt++) {
      const cart = await readCart();
      const lines = protectionLines(cart);
      const stray = lines.find(entry => String(entry.variant_id) !== String(variantId));
      if (stray) {
        // The old line leaves first, so the quoted variant can never be duplicated.
        await writeCart(copy.changeUrl, {id:stray.key, quantity:0}).catch(() => null);
        continue;
      }
      const keep = lines[0];
      if (keep && Number(keep.quantity) > 1) {
        await writeCart(copy.changeUrl, {id:keep.key, quantity:1}).catch(() => null);
        continue;
      }
      if (!keep) {
        await writeCart(copy.addUrl, {items:[{id:variantId, quantity:1}]}).catch(() => null);
      }
      const confirmed = await readCart();
      if (lineIsCurrent(confirmed)) return confirmed;
    }
    throw new Error('Protection could not be confirmed');
  }
  async function includeProtection(options) {
    const awaitQuote = Boolean(options && options.awaitQuote);
    const known = options && options.cart;
    return locked(async () => {
      resolveProtectionVariant();
      // The automatic add waits for a republished quote to settle before it reads
      // the cart, so the cart it confirms still matches the tier it adds.
      if (awaitQuote && quoteSettling()) throw new Error('Protection is settling');
      const cart = known && Array.isArray(known.items) ? known : await readCart();
      if (!cart || !Array.isArray(cart.items) || !cart.items.length) return cart;
      // Without a resolved quote there is nothing to compare the line against, so an
      // existing line is left exactly as the app put it.
      if (protectionLine(cart) && !protectionVariantId) return cart;
      // A line the previous cart left behind is not accepted just because it is
      // present: it is kept only when it is the variant this quote resolved.
      if (lineIsCurrent(cart)) return cart;
      const confirmed = await confirmReview(cart);
      if (lineIsCurrent(confirmed)) return confirmed;
      const existing = protectionLine(confirmed);
      // Automatic inclusion only ever uses the resolved variant id. Navidium's
      // controller redirects to checkout, which is wrong for a background add.
      resolveProtectionVariant();
      // Navidium can republish while the cart is being read, so the resolved
      // variant is revalidated against the stored quote right before the write.
      if (awaitQuote && (quoteSettling() || !protectionVariantId)) {
        throw new Error('Protection is unavailable');
      }
      if (!protectionVariantId) throw new Error('Protection is unavailable');
      if (existing) return writeProtectionLine(confirmed, protectionVariantId);
      await writeCart(copy.addUrl, {items:[{id:protectionVariantId, quantity:1}]});
      for (let attempt = 0; attempt < 4; attempt++) {
        const after = await readCart();
        const found = protectionLine(after);
        if (found) {
          if (found.quantity > 1) {
            // Never leave a duplicated protection line behind.
            await writeCart(copy.changeUrl, {id:found.key, quantity:1}).catch(() => null);
            return readCart();
          }
          return after;
        }
        if (attempt < 3) await pause(500);
      }
      throw new Error('Protection could not be confirmed');
    });
  }
  async function excludeProtection() {
    return locked(async () => {
      const cart = await readCart();
      const line = protectionLine(cart);
      if (!line) return cart;
      if (reviewBusy()) throw new Error('Cart is busy');
      await writeCart(copy.changeUrl, {id:line.key, quantity:0});
      const after = await readCart();
      if (protectionLine(after)) throw new Error('Protection could not be removed');
      return after;
    });
  }
  async function reconcile(withProtection) {
    const cart = await readCart();
    if (!cart || !Array.isArray(cart.items)) throw new Error('Cart could not be read');
    if (Boolean(protectionLine(cart)) === withProtection) return cart;
    return withProtection ? includeProtection() : excludeProtection();
  }
  function applyCart(cart, options) {
    if (!cart) return;
    const line = protectionLine(cart);
    const present = Boolean(line);
    inCart = present;
    // The cart's own line price is the only authoritative price while the
    // protection line is present, whatever the app text or product tier says.
    linePrice = line ? formatMoney(Number(line.final_line_price)) : '';
    if (!choiceTouched && choice) choice.checked = present;
    // A confirmed no-op (the cart already holds the quoted line) keeps the markup
    // it has, so a same-tier add never rewrites or flashes the rows.
    if (options && options.rebuild === false) {
      queueSync();
      return;
    }
    rebuild();
  }
  async function saveNote(note) {
    if (!note) return;
    const response = await fetch(copy.updateUrl, {
      method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({note:note.value}), signal:AbortSignal.timeout(10000)
    });
    if (!response.ok) throw new Error('Note could not be saved');
  }
  function endCycle() {
    cycleActive = false;
    window.clearTimeout(cycleTimer);
    cycleTimer = 0;
  }
  function beginCycle() {
    cycleId++;
    cycleActive = true;
    window.clearTimeout(cycleTimer);
    cycleTimer = window.setTimeout(expireCycle, cycleLimit);
  }
  // The cycle has to announce itself even when the cart never answers, otherwise the
  // panel would sit on its own fallback instead of showing the cart as it stands.
  function expireCycle() {
    cycleTimer = 0;
    if (!cycleActive) return;
    endCycle();
    autoDone = true;
    // A rebuild that never announced still ends the wait here.
    if (addedEpoch >= renderEpoch) addedEpoch = renderEpoch - 1;
    queueSync();
  }
  // A quote republished after the cycle closed still describes a different tier, so
  // the line is reconciled again while the bounded watch is running.
  function beginQuoteFollowUp() {
    if (quoteFollowUps >= maxQuoteFollowUps) return;
    quoteFollowUps++;
    settled = false;
    autoDone = false;
    autoTries = 0;
    variantFetches = 0;
    settleWaits = 0;
    beginCycle();
    queueAutoInclude(0);
  }
  // A quote that is still being rewritten spends no add budget: only the decision
  // itself is postponed, and the bounded cycle deadline still releases the panel.
  function deferCycle(delay) {
    autoTries = Math.max(1, autoTries - 1);
    settleWaits = 0;
    scheduleAutoRetry(delay + 50);
  }
  function queueAutoInclude(delay) {
    if (autoDone) return;
    // Nothing is added before Navidium's bounded publication window has closed, so
    // an early observer or idle signal cannot race the first quote.
    const wait = Math.max(delay || 0, autoStartAt - Date.now());
    window.clearTimeout(autoTimer);
    autoTimer = window.setTimeout(autoInclude, wait > 0 ? wait : 0);
  }
  function scheduleAutoRetry(delay) {
    if (autoDone) return;
    window.clearTimeout(autoTimer);
    autoTimer = window.setTimeout(autoInclude, delay || 400 * autoTries);
  }
  function startQuoteWatch() {
    if (quoteWatchTimer) return;
    const deadline = Date.now() + quoteWatchLimit;
    quoteWatchTimer = window.setInterval(() => {
      // A protection line being present no longer stops the watch: the quote can
      // still move to a new tier after the line was written.
      if (optedOut() || Date.now() > deadline) {
        stopQuoteWatch();
        return;
      }
      // A write already in flight owns the quote it resolved.
      if (mutating || proceeding) return;
      // Navidium republishes its stored variant and price without an event this
      // controller can rely on, so the keys are watched directly.
      if (!reconcileQuote()) return;
      if (!cycleActive) beginQuoteFollowUp();
      queueSync();
      queueAutoInclude(0);
    }, quoteWatchInterval);
  }
  function stopQuoteWatch() {
    if (!quoteWatchTimer) return;
    window.clearInterval(quoteWatchTimer);
    quoteWatchTimer = 0;
  }
  async function autoInclude() {
    if (autoDone || mutating || proceeding) return;
    if (!synced || count < 1 || choiceTouched || optedOut()) {
      // Nothing in this cycle can change the cart, so the cycle ends now instead of
      // holding the panel back for the rest of its bound.
      endCycle();
      return;
    }
    // Waiting for the post-add quote spends no add budget: the bounded gate and the
    // settle window only decide when the stored quote may be used.
    const gate = quoteGateWait();
    if (gate > 0) {
      scheduleAutoRetry(gate + 50);
      return;
    }
    const settling = settleWait();
    if (settling > 0 && settleWaits < maxSettleWaits) {
      settleWaits++;
      scheduleAutoRetry(settling + 50);
      return;
    }
    if (autoTries >= maxAutoTries) {
      autoDone = true;
      endCycle();
      queueSync();
      return;
    }
    if (!protectionVariantId) resolveProtectionVariant();
    if (!protectionVariantId) {
      // Navidium is still initializing: spend one bounded try and retry instead of
      // leaving the first add of the session without protection.
      autoTries++;
      if (autoTries >= maxAutoTries) {
        autoDone = true;
        endCycle();
      } else {
        scheduleAutoRetry(variantRetryDelay);
      }
      // Lets the settled check see the spent try without waiting for a render.
      queueSync();
      return;
    }
    autoTries++;
    mutating = true;
    sync();
    try {
      // The quote is re-read before anything is decided: a republish that landed
      // during the wait has to settle before the line may be judged current.
      const moving = quoteReloading() || quoteConsistencyWaitLeft();
      if (moving > 0) {
        deferCycle(moving);
        return;
      }
      const cart = await readCart();
      // Navidium can write its keys again while the cart is being read.
      const late = quoteReloading() || quoteConsistencyWaitLeft();
      if (late > 0) {
        deferCycle(late);
        return;
      }
      // The cart it just read decides between an untouched line and a rewritten one,
      // so a same-tier add never sends a write it does not need.
      if (lineIsCurrent(cart)) applyCart(cart, {rebuild:false});
      else applyCart(await includeProtection({awaitQuote:true, cart}));
      autoDone = true;
      endCycle();
    } catch (error) {
      // A busy price review, a settling quote or a refused add must never block
      // checkout; the reconciliation is retried while the bounded budget lasts. A
      // quote that moved while the write was prepared only waits out the settle
      // window instead of the longer add backoff.
      const settling = /settling/i.test((error && error.message) || '');
      if (autoTries >= maxAutoTries) {
        autoDone = true;
        endCycle();
      } else if (settling) {
        deferCycle(quoteSettleDelay);
      } else {
        scheduleAutoRetry();
      }
    } finally {
      mutating = false;
      queueSync();
    }
  }
  // Protection is settled when nothing further will change the cart on this pass:
  // the line is there and current, it can never be there, the shopper declined it,
  // the cart is empty, or the automatic reconciliation finished or ran out of tries.
  function settledReason() {
    if (count < 1) return 'empty';
    if (optedOut()) return 'opted-out';
    // A line being present is not a settled state while a cycle is still deciding
    // whether that line is the one the current quote asks for.
    if (cycleActive) return '';
    if (inCart) return 'present';
    // A missing variant only settles once the bounded variant resolution is spent,
    // because Navidium can publish its variant and price after the first render.
    if (!protectionVariantId) return autoTries >= maxAutoTries || choiceTouched ? 'no-variant' : '';
    if (autoDone && autoTries >= maxAutoTries) return 'exhausted';
    return '';
  }
  function maybeSettle() {
    if (settled || mutating || renderPending) return;
    // After an add the state has to be read from a render that landed after that
    // add, so a stale pre-add count can never settle the new cycle early.
    if (renderEpoch <= addedEpoch) return;
    const reason = settledReason();
    if (!reason) return;
    // One notification per settled cycle: the population-out waits on this once.
    settled = true;
    document.dispatchEvent(new CustomEvent('fs:protection-settled', {detail:{reason, cycle:cycleId}}));
  }
  function sync() {
    scheduled = false;
    const state = form.querySelector('[data-fs-cart-state]');
    if (!state) return;
    count = Number(state.dataset.count);
    const dom = state.dataset.protection === 'true';
    if (dom !== protectionDom) {
      // A native removal of the protection line is an explicit opt-out.
      if (protectionDom === true && !dom && !mutating && !proceeding && !fuelLoading && count > 0) setOptedOut(true);
      protectionDom = dom;
      inCart = dom;
    }
    money(form.querySelector('[data-fs-sticky-subtotal]'), state.dataset.subtotalMoney);
    money(form.querySelector('[data-fs-cart-savings]'), state.dataset.savingsMoney);
    const savingsRow = form.querySelector('[data-fs-cart-savings-row]');
    if (savingsRow) savingsRow.hidden = !(Number(state.dataset.savings) > 0);
    text(page.querySelector('[data-fs-cart-count]'), `(${count})`);
    if (!choiceTouched && choice) choice.checked = inCart;
    if (!protectionVariantId) resolveProtectionVariant();
    const app = appButtons();
    const appPrice = app.price ? app.price.textContent.trim() : '';
    // The app price is the prospective quote only; it never overrides the cart's
    // own line price while the protection line is in the cart.
    if (appPrice && !inCart) price = appPrice;
    const rendered = Boolean(app.withProtection && app.withoutProtection && appPrice);
    enhanced = rendered || inCart || Boolean(protectionVariantId && price);
    page.classList.toggle('fs-cart-enhanced', enhanced);
    if (protection) protection.hidden = !enhanced;
    if (skipLink) skipLink.hidden = !enhanced;
    if (buttons[0]) buttons[0].hidden = !enhanced;
    // Included: show the actual line-item price (blank until it is known) so a
    // mismatched app or product price is never displayed. Prospective: unchanged
    // app/product fallback.
    const shown = inCart ? linePrice : price;
    if (enhanced && (inCart || shown)) text(form.querySelector('[data-fs-protection-price]'), shown);
    if (inCart) loadLinePrice();
    else if (!price) loadPrice();
    const selected = Boolean(choice && choice.checked);
    if (protectionNote) text(protectionNote, dom ? (selected ? copy.included : copy.remove) : (selected ? copy.selected : copy.optional));
    const loading = Boolean(form.querySelector('.is-loading'));
    buttons.forEach(button => { button.disabled = proceeding || mutating || loading || !count; });
    if (bar) bar.hidden = !count;
    if (!count) {
      // An emptied cart always resets the opt-out so the next shopping session
      // gets protection included again.
      setOptedOut(false);
      // Only the cart page reloads into its empty state; the drawer renders the
      // empty state itself and a reload would eject the shopper mid-pop-out.
      if (!drawer) window.location.reload();
    } else if (!mutating) {
      // The first render that has items is also this cycle's first inclusion
      // chance, so it schedules the same way every later render does.
      synced = true;
      queueAutoInclude(autoTries ? 350 : 0);
    }
    if (!loadCycleStarted && addedEpoch < 0 && count > 0 && inCart && !optedOut()) {
      // A page load that already holds protection still has to prove the line
      // belongs to the current quote, so the regular /cart view recalculates its
      // tier exactly like an add does instead of trusting what it was served.
      loadCycleStarted = true;
      if (!cycleActive) beginCycle();
      queueAutoInclude(0);
    }
    // Fee-only carts are cleaned up here too, so removing the last product also
    // removes the lines that only exist to price merchandise.
    ensureFuelLine();
    maybeSettle();
  }
  function queueSync() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  }
  async function checkProtection() {
    const previous = optedOut();
    setOptedOut(false);
    mutating = true;
    error.hidden = true;
    sync();
    try {
      applyCart(await includeProtection());
      autoDone = true;
    } catch (_) {
      setOptedOut(previous);
      if (choice) choice.checked = inCart;
      showError(copy.error);
    } finally {
      mutating = false;
      sync();
    }
  }
  async function uncheckProtection() {
    const previous = optedOut();
    setOptedOut(true);
    mutating = true;
    error.hidden = true;
    sync();
    try {
      applyCart(await excludeProtection());
      autoDone = true;
    } catch (_) {
      setOptedOut(previous);
      if (choice) choice.checked = inCart;
      showError(copy.error);
    } finally {
      mutating = false;
      sync();
    }
  }
  if (choice) choice.addEventListener('change', () => {
    if (mutating || proceeding) {
      choice.checked = inCart;
      return;
    }
    choiceTouched = true;
    if (choice.checked) checkProtection();
    else uncheckProtection();
  });
  function submitNative() {
    const native = form.querySelector('.cart__checkout');
    if (native && typeof form.requestSubmit === 'function') {
      form.requestSubmit(native);
      return;
    }
    window.location.href = '/checkout';
  }
  async function proceed(withProtection) {
    if (proceeding) return;
    error.hidden = true;
    if (mutating || form.querySelector('.is-loading')) {
      showError(copy.busy);
      return;
    }
    const terms = form.querySelector('.cart__terms-checkbox');
    if (terms && !terms.checked) {
      showError(copy.terms);
      terms.focus();
      return;
    }
    if (!enhanced) {
      const summary = form.querySelector('.fs-cart-summary');
      if (summary) summary.scrollIntoView({block:'center',behavior:'smooth'});
      const native = form.querySelector('.cart__checkout');
      if (native) native.focus({preventScroll:true});
      return;
    }
    const app = appButtons();
    const rendered = Boolean(app.withProtection && app.withoutProtection);
    const target = withProtection ? app.withProtection : app.withoutProtection;
    if (rendered && (!target || target.disabled)) {
      showError(copy.busy);
      queueSync();
      return;
    }
    proceeding = true;
    sync();
    try {
      await saveNote(form.querySelector('[name="note"]'));
      // Choosing checkout without protection is an explicit opt-out, so a later
      // cart visit must not auto-include it again.
      if (!withProtection) setOptedOut(true);
      if (rendered) {
        // Navidium owns the button it rendered, so its without-protection button
        // performs the removal and the checkout itself. Reconciling here first
        // issued a second change request for the same line and failed.
        target.click();
      } else {
        // The native submit has no app button to remove the declined line, so the
        // line is removed and confirmed here first.
        let unprotected = false;
        if (withProtection) {
          try {
            applyCart(await reconcile(true));
          } catch (_) {
            // Protection could not be added or confirmed. Continue with native
            // checkout on the cart exactly as it stands instead of stranding the
            // shopper; a single native submit cannot charge protection twice.
            unprotected = true;
          }
        } else {
          // A failed removal must not check out with the wrong cart state.
          applyCart(await reconcile(false));
        }
        submitNative();
        if (unprotected) showError(copy.error);
      }
      window.setTimeout(() => {
        if (document.visibilityState !== 'hidden') {
          showError(copy.error);
        }
      }, 20000);
    } catch (failure) {
      proceeding = false;
      showError(copy.error);
      sync();
    }
  }
  function checkout() {
    return proceed(choice ? choice.checked : inCart);
  }
  buttons.forEach(button => button.addEventListener('click', checkout));
  if (skipLink) skipLink.addEventListener('click', event => {
    event.preventDefault();
    if (proceeding) return;
    return proceed(false);
  });
  new MutationObserver(queueSync).observe(form, {childList:true,subtree:true,attributes:true,attributeFilter:['class']});
  const appMount = form.querySelector('.nvd-mini');
  if (appMount) new MutationObserver(queueSync).observe(appMount, {childList:true,subtree:true,characterData:true});
  window.addEventListener('pageshow', () => {
    proceeding = false;
    mutating = false;
    error.hidden = true;
    queueSync();
  });
  document.addEventListener('cart:updated', queueSync);
  document.addEventListener('cart:rendered', () => {
    // The rebuild this controller requested has now replaced the rows and the
    // subtotal, so its settled check may run against the rendered state.
    renderPending = false;
    renderEpoch++;
    window.clearTimeout(renderTimer);
    sync();
  });
  document.addEventListener('ajaxProduct:added', () => {
    // A new add runs its own protection reconciliation; the previous settled
    // signal must not let the drawer open before this cycle has finished.
    settled = false;
    renderPending = false;
    // Each add gets its own bounded resolution and auto-include budget, so a page
    // load that already spent it can never settle the new add early.
    autoDone = false;
    autoTries = 0;
    variantFetches = 0;
    settleWaits = 0;
    quoteFollowUps = 0;
    addedEpoch = renderEpoch;
    window.clearTimeout(renderTimer);
    // The stored quote belongs to the previous cart until Navidium republishes it.
    openQuoteGate();
    // The line already in the cart can belong to that previous tier, so the add
    // starts a cycle that has to confirm or replace it before anything settles.
    beginCycle();
    // A bigger cart republishes a new tier, so the quote is watched again.
    stopQuoteWatch();
    startQuoteWatch();
  });
  document.addEventListener('fs:cart-idle', () => queueAutoInclude(0));
  markFeeTestCart();
  sync();
  queueAutoInclude(initialQuoteDelay);
  startQuoteWatch();
  // The native cart renderer can insert the state after the first sync, so the
  // enhanced UI gets two bounded late chances to initialize.
  window.setTimeout(sync, 250);
  window.setTimeout(sync, 1000);
})();
